import React, { useEffect, useState } from 'react';
import type { UploadFile } from 'antd/es/upload/interface';
import type { RcFile, UploadProps } from 'antd/es/upload';
import { getBase64 } from "../../helpers/FormHelper";

import { Form, Modal, Upload } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DeleteOutlined } from "@ant-design/icons";

import './style.scss';

interface propsInterface {
  name: string;
  label: string;
  rules?: any;
  preview?: string | undefined;
  onClickDestroy?: Function;
}

function FileDropzone({ name, label, rules, preview, onClickDestroy }: propsInterface) {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState<string | null>(preview || null);

  const normFile = (e: any) => e?.file;
  const handleCancel = () => setPreviewOpen(false);

  useEffect(() => {
    setPreviewImage(preview || null);
  }, [preview])

  const handlePreview = () => {
    setPreviewOpen(true);
  }

  function handleDestroy(e: any) {
    e.stopPropagation();
    setPreviewImage(null);
    setFileList([]);

    if (onClickDestroy) {
      onClickDestroy();
    }
  }

  const addPreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file as RcFile);
    }

    setPreviewImage(file.url || (file.preview as string));
  }

  const props: UploadProps = {
    onRemove: file => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();

      newFileList.splice(index, 1);
      setFileList(newFileList);
      setPreviewImage(null);
    },

    beforeUpload: file => {
      addPreview(file).then(() => setFileList([file]));

      return false;
    },

    fileList
  };

  const DestroyIcon = () => {
    return (
      <span className='v-dropzone--destroy-icon'>
        <DeleteOutlined onClick={handleDestroy} />
      </span>
    )
  }

  const UploadButton = () => {
    if(previewImage) {
      return (
        <div className='v-dropzone-preview'>
          <img alt="preview" className='o-image' src={previewImage} />

          {onClickDestroy && previewImage && <DestroyIcon />}
        </div>
      )
    } else {
      return <FontAwesomeIcon icon={['far', 'image']} />
    }
  }

  return (
    <>
      <Form.Item
        name={name}
        label={label}
        normalize={normFile}
        rules={rules}
      >
        <Upload
          {...props}
          listType="picture-card"
          showUploadList={false}
          maxCount={1}
        >
          <UploadButton />
        </Upload>
      </Form.Item>

      <Modal open={previewOpen} title={null} footer={null} onCancel={handleCancel}>
        {previewImage && <img alt="preview" style={{ width: '100%' }} src={previewImage} />}
      </Modal>
    </>
  )
}

export default FileDropzone;
